import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AcountRestriction } from '../../Models/Domains/Account/AcountRestriction';
import { RestrictionTypeEnum } from '../../Constants/Enums/RestrictionTypeEnum';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountRestrictionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyid: string, restrictionType: RestrictionTypeEnum): Promise<AcountRestriction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountRestriction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyid: hierarchyid, restrictionType: restrictionType }

    return AjaxWrapper.get<AcountRestriction, any>(url, data);
  }
}

